<template>
    <BaseControl
        :has-append="$attrs.hasControls"
        :has-prepend="$attrs.hasControls"
        v-bind="$attrs"
        class="position-relative table-filter-datepicker"
        :errors="combinedErrors"
    >
        <p-datepicker
            ref="input"
            :placeholder="_placeholder"
            v-model="local"
            :class="classes"
            class="date-picker-input"
            :config="options"
            :readonly="isReadOnly"
            :disabled="isDisabled"
        >
        </p-datepicker>

        <div class="icon position-absolute" @click="focusField()">
            <i class="fa fa-calendar-alt" />
        </div>

        <template v-if="$attrs.hasControls" #append>
            <b-button @click="addDays(1)" variant="light-outline"><i class="fa fa-chevron-right" /></b-button>
        </template>

        <template v-if="$attrs.hasControls" #prepend>
            <b-button @click="addDays(-1)" variant="light-outline"><i class="fa fa-chevron-left" /></b-button>
        </template>
    </BaseControl>
</template>

<script>
import BaseControl from "@Platon/components/form/controls/BaseControl.vue"
import ValidationMixin from "@Platon/mixins/ValidationMixin"
import { DEFAULT_DATE_FORMAT, DEFAULT_SERVER_DATE_FORMAT } from "@Platon/const"
import moment from "moment"
import "@Platon/external/datepicker/lang-la.js"
import DatepickerMixin from "@Platon/components/form/controls/DatepickerMixin"
import { localeInfo } from "@Platon/core/translations"
import InputControl2Mixin from "@Platon/mixins/InputControl2Mixin"

export default {
    name: "DateControl",

    mixins: [InputControl2Mixin, ValidationMixin, DatepickerMixin],

    props: {
        value: {}
    },

    components: {
        BaseControl
    },

    data() {
        let local = moment(this.value || this.item.defaultValue, DEFAULT_SERVER_DATE_FORMAT)
        let dateFormat = this.item.format || DEFAULT_DATE_FORMAT

        return {
            dateFormat: dateFormat,
            local: local.isValid() ? local.format(dateFormat) : null
        }
    },

    watch: {
        local(val) {
            let emitValue = val ? moment(val, this.dateFormat).format(DEFAULT_SERVER_DATE_FORMAT) : null

            if (emitValue !== this.value) this.$emit("input", emitValue)
        },

        value(val) {
            this.local = val ? moment(val, DEFAULT_SERVER_DATE_FORMAT).format(this.dateFormat) : null
        }
    },

    computed: {
        options() {
            let extra = {}

            if (this.item.minDate) {
                let date = moment(this.item.minDate, DEFAULT_SERVER_DATE_FORMAT).toDate()
                date.setHours(0, 0, 0)

                extra.minDate = date
            }

            if (this.item.maxDate) {
                let date = moment(this.item.maxDate, DEFAULT_SERVER_DATE_FORMAT).toDate()
                date.setHours(0, 0, 0)

                extra.maxDate = date
            }

            return {
                format: this.dateFormat,
                locale: localeInfo.locale,
                useCurrent: false,
                showClear: true,
                showClose: true,
                // widgetParent: 'body',
                ...extra
            }
        },

        classes() {
            return [`text-${this.item.textAlign || "left"}`]
        },

        _placeholder() {
            return this.$props.placeholder || this.item.placeholder || this.dateFormat
        }
    }
}
</script>

<style scoped>
.icon {
    right: 1rem;
    bottom: 0.5rem;
}
</style>
